import { cx } from 'emotion';

import { Clock, TIME_PATTERNS, Timer } from '@ezugi/primitives';

import Text from '../Text';
import {
  fixedSpacer,
  timerContainer,
  timersWrapper,
  legacyTimers,
} from './style.css';

const RoundInfo = ({
  roundId,
  showSeconds = true,
  legacy = false,
}: {
  roundId: number;
  showSeconds: boolean;
  legacy: boolean;
}) => (
  <div className={cx(timersWrapper, { [legacyTimers]: legacy })}>
    <span data-e2e="footer-clock">
      <Clock format="hh:mm" />
    </span>
    <div className={fixedSpacer} />
    <span data-e2e="footer-timer" className={timerContainer}>
      <Timer
        start={undefined}
        end={undefined}
        callback={undefined}
        format={
          showSeconds
            ? undefined
            : `${TIME_PATTERNS.HOURS}:${TIME_PATTERNS.MINUTES}`
        }
      >
        {null}
      </Timer>
    </span>
    <Text data-e2e="round-info" boldValue={false} label="" value={`#${roundId}`} />
  </div>
);

export default RoundInfo;
